import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/public/password`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  forgottenPassword({commit}, payload: {email: string}) {
    return axiosInstance.post(`${baseUrl}/forgotten`, {
      email: payload.email,
    });
  },
  updatePassword({commit}, payload: {token: number, password: object}) {
    return axiosInstance.put(`${baseUrl}/update`, {
      token: payload.token,
      password: payload.password,
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
